import {createContext, useContext} from 'react';
import {FileContextProviderState} from './types/FileContextProviderProps';

/**
 * @constant FileInputContext set default value for FileInputContext
 */
export const FileInputContext = createContext<FileContextProviderState | undefined>(undefined);

export const useFileInputContext = (): FileContextProviderState => {
    const context = useContext(FileInputContext);

    if (!context) {
        throw Error(
            'useFileInputContext() can only be called inside the FileContextProvider component'
        );
    }

    return context;
};
